import { CalculatedFieldTable } from "./calculated-field-tables";

export enum CalculatedFieldReturnType {
	BOOL = "boolean",
	NUMBER = "number",
	STRING = "string",
	DATE = "date",
	DURATION = "duration",
}

export function getAllCalculatedFieldReturnTypes():CalculatedFieldReturnType[]{
	return Object.values(CalculatedFieldReturnType);
}

export class CalculatedField {
	ID:number = 0;
	Table:CalculatedFieldTable = CalculatedFieldTable.CONTACT;
	Name:string = "New field";
	JsCode:string = "return 1";
	Preloads:string[] = [];
	ReturnType:CalculatedFieldReturnType = CalculatedFieldReturnType.NUMBER;
	DisplayOrder:number = 0;

	public constructor(data?:any) {
		if (!data) return;
		this.ID = data.ID;
		this.Name = data.Name;
		this.Table = data.Table;
		this.JsCode = data.JsCode;
		this.Preloads = data.Preloads;
		this.ReturnType = data.ReturnType;
		this.DisplayOrder = data.DisplayOrder;
	}

	public getJSON(){
		return {
			ID: this.ID,
			Table: this.Table,
			Name: this.Name,
			JsCode: this.JsCode,
			Preloads: this.Preloads,
			ReturnType: this.ReturnType,
			DisplayOrder: this.DisplayOrder,
		};
	}
}